import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
    supportTicket: {
        id: 'support.ticket.title',
        defaultMessage: 'Support Ticket',
        description: 'Title for the support ticket page',
    },
    noMessagesYet: {
        id: 'support.ticket.noMessages',
        defaultMessage: 'No messages yet',
        description: 'Message shown when there are no messages in the ticket',
    },
    typeYourMessage: {
        id: 'support.ticket.typeMessage',
        defaultMessage: 'Type your message...',
        description: 'Placeholder for the message input field',
    },
    send: {
        id: 'support.ticket.send',
        defaultMessage: 'Send',
        description: 'Label for the send button',
    },
    assignedTo: {
        id: 'support.ticket.assignedTo',
        defaultMessage: 'Assigned to',
        description: 'Label for the assigned to field',
    },
});

export default messages;
